import { jsx as _jsx } from "react/jsx-runtime";
import SystemMode from "@mui/icons-material/AutoAwesome";
import DarkMode from "@mui/icons-material/DarkMode";
import LightMode from "@mui/icons-material/LightMode";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tooltip from "@mui/material/Tooltip";
import { useColorScheme } from "@mui/material/styles";
const options = [
    {
        icon: _jsx(LightMode, {}),
        value: "light",
        label: "Light mode",
    },
    {
        icon: _jsx(DarkMode, {}),
        value: "dark",
        label: "Dark mode",
    },
    {
        icon: _jsx(SystemMode, {}),
        value: "system",
        label: "Light or dark mode depending on system settings",
    },
];
export function ColorSchemeSwitcher(props) {
    const { size = "small", sx = {} } = props;
    const { mode, setMode } = useColorScheme();
    return (_jsx(ToggleButtonGroup, { exclusive: true, value: mode, size: size, sx: sx, children: options.map((option) => (_jsx(Tooltip, { title: option.label, children: _jsx(ToggleButton, { value: option.value, onClick: () => setMode(option.value), children: option.icon }) }, option.value))) }));
}
//# sourceMappingURL=ColorSchemeSwitcher.js.map